import { TextField } from "react-admin"

export const TruncatedTextField = ({...props}) => {
    return <TextField {...props} sx={{
                      display: 'block',
                      maxWidth: 300,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}/>
}

export const WrappingTextField = ({...props}) => {
    return <TextField {...props} sx={{
                maxWidth: 300, // You can also use '100%' for flexible width
                whiteSpace: 'normal', 
                wordBreak: 'break-word', // Forces long unbroken words to wrap
            }}/>
}